/* eslint-disable camelcase */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import { createReducer } from "../../../utils/redux/create-reducer";
import { STEP_NAMES } from "../../../constants/app-constants";
import { SELL_ONLINE_STEP_KEY, SELL_ONLINE_TAB_LIST } from "../../../constants/sell-online-constant";
import parsePriceRanges from "../../../utils/parsers/parse-price-ranges";
import { LEAD_STEPS } from "./constant";
import Types from "./types";

const getStepindex = (currentStep, tabs = SELL_ONLINE_TAB_LIST) => {
    const currentTab = tabs.filter(tab =>
        currentStep.toLowerCase() === tab.key.toLowerCase()
    );
    return currentTab && currentTab[0].index;
};

export const INITIAL_STATE = {
    brand: { displayText: "", id: null },
    model: { displayText: "", id: null },
    year: { displayText: "", id: null, year_id: null },
    fuelType: { displayText: "" },
    transmission: { displayText: "" },
    registrationState: { displayText: "", id: null },
    variant: { displayText: "", id: null },
    kilometersDriven: { displayText: "", id: null },
    rto: { displayText: "", id: null },
    branch: { displayText: "", id: null, selectionType: "city" },
    currentStep: SELL_ONLINE_STEP_KEY.BASIC_DETAILS,
    currentProgressStep: "",
    currentStepIndex: 1,
    currentTabIndex: getStepindex(SELL_ONLINE_STEP_KEY.BASIC_DETAILS),
    prevTabIndex: 0,
    proceedCTA: false,
    token: null,
    error: null,
    activateLastStep: false,
    priceRange: {},
    source: null,
    isLeadFormChanged: false,
    flowName: "default",
    ctaLocation: null,
    basicDetailCompleteWithLocation: {},
    carConditionQuestions: [],
    currentQuestionIndex: 0,
    userResponse: {},
    selectedInspectionDate: null,
    selectedInspectionTime: null,
    locationName: ""
};

const isDataChanged = (before, after) => {
    if (before && after) {
        return before !== after;
    } else {
        return false;
    }
};

const updateLeadFormState = ({
    state,
    currentStep,
    value,
    activateLastStep = false
}) => {
    const precedingValues = {};
    const stepIndex = LEAD_STEPS.filter((tab) => tab.name === currentStep)[0].index;
    let nextStepIndex = null;
    if (stepIndex) {
        nextStepIndex = stepIndex + 1;
    }
    const isDifferentStep = !!(currentStep === STEP_NAMES.FuelType || currentStep === STEP_NAMES.Transmission);
    const dataChanged = isDataChanged(isDifferentStep ? state[currentStep].displayText : state[currentStep].id, isDifferentStep ? value.displayText : value.id);
    if (dataChanged && stepIndex) {
        for (let index = nextStepIndex; index <= LEAD_STEPS.length; index++) {
            if (LEAD_STEPS[index - 1].name === STEP_NAMES.Year) {
                precedingValues[LEAD_STEPS[index - 1].name] = { displayText: "", id: null, year_id: null };
            } else {
                precedingValues[LEAD_STEPS[index - 1].name] = { displayText: "", id: null };
            }
        }
    }

    // else  if (LEAD_STEPS[index - 1].name === STEP_NAMES.FuelType || LEAD_STEPS[index - 1].name === STEP_NAMES.Transmission) {
    //     precedingValues[LEAD_STEPS[index - 1].name] = { displayText: "" };
    // }
    // if (currentStep === STEP_NAMES.FuelType || currentStep === STEP_NAMES.Transmission) {
    //     if (Object.keys(precedingValues).length > 0 && precedingValues.rto && precedingValues.rto.rto_id) {
    //         activateLastStep = true;
    //     }
    // }

    return {
        ...state,
        [currentStep]: value,
        activateLastStep,
        ...precedingValues
    };
};

export const setBrand = (state = INITIAL_STATE, { brand }) => {
    return updateLeadFormState({
        state,
        currentStep: STEP_NAMES.Brand,
        value: brand
    });
};

export const setModel = (state = INITIAL_STATE, { model }) => {
    return updateLeadFormState({
        state,
        currentStep: STEP_NAMES.Model,
        value: model
    });
};

export const setYear = (state = INITIAL_STATE, { year }) => {
    return updateLeadFormState({
        state,
        currentStep: STEP_NAMES.Year,
        value: year
    });
};

export const setFuelType = (state = INITIAL_STATE, { fuelType }) => {
    return {
        ...state,
        fuelType
    };
};

export const setTransmissionType = (state = INITIAL_STATE, { transmission }) => {
    return {
        ...state,
        transmission
    };
};

export const setVariant = (state = INITIAL_STATE, { variant }) => {
    return updateLeadFormState({
        state,
        currentStep: STEP_NAMES.Variant,
        value: variant
    });
};

export const setRegistrationState = (state = INITIAL_STATE, { registrationState }) => {
    return updateLeadFormState({
        state,
        currentStep: STEP_NAMES.State,
        value: registrationState
    });
};

export const setRto = (state = INITIAL_STATE, { rto }) => {
    return updateLeadFormState({
        state,
        currentStep: STEP_NAMES.RTO,
        value: rto,
        activateLastStep: true
    });
};

export const setActivateLastStep = (state = INITIAL_STATE, { flag }) => {
    return {
        ...state,
        activateLastStep: flag
    };
};

export const setStep = (state = INITIAL_STATE, { currentStep,  tabs}) => {
    const prevTabIndex = state.currentTabIndex;
    return { ...state, currentStep, prevTabIndex, currentTabIndex: getStepindex(currentStep, tabs) };
};

export const makeLeadSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        token: data.token,
        priceRange: parsePriceRanges(data),
        error: null
    };
};

export const makeLeadFailure = (state = INITIAL_STATE, { data }) => {
    return { ...state, token: null, error: data };
};
export const resetSellOnlineLeadData = (state = INITIAL_STATE, { data }) => {
    return { ...state, ...INITIAL_STATE, locationName: state.locationName, priceRange: parsePriceRanges(data) };
};
export const mergeLeadData = (state = INITIAL_STATE, { data }) => {
    const {
        token,
        make_id, make_display,
        model_id, model_display,
        year, year_id,
        variant_id, variant_display_name,
        state_id: stateId, state_name, state_code: stateCode,
        kms, kms_range,
        rto_id,
        rto_code = "NA",
        lead_type,
        fuel_type,
        transmission_type,
        whatsapp_consent
    } = data;

    return {
        ...state,
        brand: { id: make_id, displayText: make_display },
        model: { id: model_id, displayText: model_display },
        year: { id: year, displayText: year.toString(), year_id },
        fuelType: { displayText: fuel_type },
        transmission: { displayText: transmission_type },
        whatsappConsent: whatsapp_consent,
        variant: { id: variant_id, displayText: variant_display_name },
        registrationState: { id: stateId, displayText: state_name, item: {state_code: stateCode, state_id: stateId} },
        priceRange: parsePriceRanges(data),
        kilometersDriven: { id: kms, displayText: kms_range },
        token,
        source: lead_type,
        activateLastStep: rto_id ? true : false,
        ...(rto_id && { rto: { displayText: rto_code, id: rto_id } })
    };
};

export const makeLead = (state = INITIAL_STATE) => {
    return { ...state, error: null };
};

export const setAnsweredQuestions = (state = INITIAL_STATE, { key, value }) => {
    return {
        ...state,
        userResponse: {
            ...state.userResponse,
            [key]: value
        }
    };
};

export const resetQuestions = (state = INITIAL_STATE) => {
    return { ...state, currentQuestionIndex: 0, userResponse: {}, activeScreen: "SODetail" };
};

export const updateQuestionsArray = (state = INITIAL_STATE, { questionArray }) => {
    return {
        ...state,
        carConditionQuestions: questionArray
    };
};

export const setCurrentQuestionIndex = (state = INITIAL_STATE, { index }) => {
    return { ...state, currentQuestionIndex: index };
};

export const setSelectedDate = (state = INITIAL_STATE, { date }) => {
    return { ...state, selectedInspectionDate: date };
};

export const setSelectedTime = (state = INITIAL_STATE, { time }) => {
    return { ...state, selectedInspectionTime: time };
};

export const setLocationName = (state = INITIAL_STATE, { location }) => {
    return { ...state, locationName: location };
};

export const setToken = (state = INITIAL_STATE, { token }) => {
    return { ...state, token };
};

export const setKilometersDriven = (state = INITIAL_STATE, { kilometersDriven }) => {
    return { ...state, kilometersDriven };
};
export const setBasicDetailCompleteWithLocation = (state = INITIAL_STATE, { data }) => {
    return { ...state, basicDetailCompleteWithLocation: data };
};
export const HANDLERS = {
    [Types.SET_BRAND]: setBrand,
    [Types.SET_MODEL]: setModel,
    [Types.SET_YEAR]: setYear,
    [Types.SET_FUEL_TYPE]: setFuelType,
    [Types.SET_TRANSMISSION_TYPE]: setTransmissionType,
    [Types.SET_VARIANT]: setVariant,
    [Types.SET_REGISTRATION_STATE]: setRegistrationState,
    [Types.SET_RTO]: setRto,
    [Types.ACTIVATE_LAST_STEP]: setActivateLastStep,
    [Types.SET_CURRENT_STEP]: setStep,
    [Types.MAKE_LEAD]: makeLead,
    [Types.MAKE_LEAD_SUCCESS]: makeLeadSuccess,
    [Types.MAKE_LEAD_FAILURE]: makeLeadFailure,
    [Types.MERGE_LEAD_DATA]: mergeLeadData,
    [Types.STORE_ANSWERED_QUESTION]: setAnsweredQuestions,
    [Types.SET_CURRENT_QUESTION_INDEX]: setCurrentQuestionIndex,
    [Types.SET_SELECTED_DATE]: setSelectedDate,
    [Types.SET_SELECTED_TIME]: setSelectedTime,
    [Types.SET_LOCATION_NAME]: setLocationName,
    [Types.SET_QUESTIONS_ARRAY]: updateQuestionsArray,
    [Types.SET_TOKEN]: setToken,
    [Types.SET_KILOMETERS_DRIVEN]: setKilometersDriven,
    [Types.SET_BASIC_DETAILS_COMPLETE]: setBasicDetailCompleteWithLocation,
    [Types.RESET_SELLONLINE_LEAD_FORM_DATA]: resetSellOnlineLeadData
};

export default createReducer(INITIAL_STATE, HANDLERS);
